import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { useAuth } from "../../Context/auth";

// --- Funções de formatação ---
const handleValorChange = (e, setState) => {
    let valor = e.target.value;
    valor = valor.replace(/[^0-9,.]/g, '');
    valor = valor.replace(',', '.');
    const partes = valor.split('.');
    if (partes.length > 2) valor = partes[0] + '.' + partes.slice(1).join('');
    if (partes[1] && partes[1].length > 2) valor = `${partes[0]}.${partes[1].substring(0, 2)}`;
    setState(valor);
};
const formatarAoPerderFoco = (valor, setState) => {
    if (!valor) return;
    const numero = parseFloat(valor);
    if (isNaN(numero)) return;
    setState(numero.toFixed(2));
};

function InsumoForm({ initialData = {}, onSubmit, isEditing = false, loading }) {
    const { currentUser } = useAuth();
    const [codigo, setCodigo] = useState('');
    const [descricao, setDescricao] = useState('');
    const [marcaId, setMarcaId] = useState('');
    const [unidadeMedidaId, setUnidadeMedidaId] = useState('');
    const [fornecedorId, setFornecedorId] = useState('');
    const [valorCompra, setValorCompra] = useState('');
    const [valorVenda, setValorVenda] = useState('');
    const [status, setStatus] = useState('Ativo');
    const [observacoes, setObservacoes] = useState('');

    const [fornecedores, setFornecedores] = useState([]);
    const [marcas, setMarcas] = useState([]);
    const [unidadesMedida, setUnidadesMedida] = useState([]);

    const [controlarCores, setControlarCores] = useState(false);
    const [colorsList, setColorsList] = useState([]);
    const [currentColor, setCurrentColor] = useState('');

    useEffect(() => {
        setCodigo(initialData.codigo || '');
        setDescricao(initialData.descricao || '');
        setMarcaId(initialData.marca_id || '');
        setUnidadeMedidaId(initialData.unidade_medida_id || '');
        setFornecedorId(initialData.fornecedor_id || '');
        setValorCompra(initialData.valor_compra ? String(initialData.valor_compra) : '');
        setValorVenda(initialData.valor_venda ? String(initialData.valor_venda) : '');
        setStatus(initialData.status || 'Ativo');
        setObservacoes(initialData.observacoes || '');

        setControlarCores(initialData.controla_cor || false);
        setColorsList(initialData.colorsList || []);

    }, [initialData]);

    useEffect(() => {
        if (!currentUser) return;
        const buscarListas = async () => {
            try {
                const token = await currentUser.getIdToken();
                const headers = { 'Authorization': `Bearer ${token}` };
                const API_URL = process.env.REACT_APP_API_URL;

                const [fornRes, marcaRes, unRes] = await Promise.all([
                    fetch(`${API_URL}/api/empresas`, { headers }),
                    fetch(`${API_URL}/api/marcas`, { headers }),
                    fetch(`${API_URL}/api/unidadesmedida`, { headers }),
                ]);

                if (!fornRes.ok || !marcaRes.ok || !unRes.ok) {
                    throw new Error('Falha ao buscar dados de suporte.');
                }

                const fornecedoresData = await fornRes.json();
                setFornecedores(fornecedoresData.filter(f => f.is_fornecedor));
                setMarcas(await marcaRes.json());
                setUnidadesMedida(await unRes.json());

            } catch (error) { console.error("Erro ao buscar listas:", error); }
        };
        buscarListas();
    }, [currentUser]);

    const handleAddColor = () => {
        const corFormatada = currentColor.trim();
        if (corFormatada === '' || colorsList.includes(corFormatada)) return;
        setColorsList([...colorsList, corFormatada].sort());
        setCurrentColor('');
    };

    const handleRemoveColor = (corToRemove) => {
        setColorsList(colorsList.filter(cor => cor !== corToRemove));
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const formData = {
            codigo, descricao, status, observacoes,
            marcaId: marcaId || null,
            fornecedorId: fornecedorId || null,
            unidadeMedidaId: unidadeMedidaId || null,
            valorCompra: parseFloat(String(valorCompra).replace(',', '.')) || 0,
            valorVenda: parseFloat(String(valorVenda).replace(',', '.')) || 0,
            controla_cor: controlarCores,
            colorsList: controlarCores ? colorsList : [],
        };
        onSubmit(formData);
    };

    return (
        <form onSubmit={handleSubmit} className="form-flex-container">
            <div className="form-scroll-area">
                <div className="row g-4">
                    <div className="col-lg-8">
                        {/* --- Seção: Dados Básicos --- */}
                        <div className="form-card">
                            <h5 className="form-section-header">
                                <i className="fas fa-info-circle me-2"></i>
                                Dados Básicos
                            </h5>
                            <div className="row g-3">
                                <div className="col-md-2">
                                    <label htmlFor="inputCodigo" className="form-label-custom">Código</label>
                                    <input onChange={(e) => setCodigo(e.target.value)} type="text" className="form-control-custom bg-light" id="inputCodigo" value={codigo} required readOnly={isEditing} />
                                </div>
                                <div className="col-md-7">
                                    <label htmlFor="inputDescricao" className="form-label-custom">Descrição *</label>
                                    <input onChange={(e) => setDescricao(e.target.value)} type="text" className="form-control-custom" id="inputDescricao" value={descricao} required placeholder="Ex: Tecido Algodão" />
                                </div>
                                <div className="col-md-3">
                                    <label htmlFor="selectStatus" className="form-label-custom">Status</label>
                                    <select id="selectStatus" className="form-select-custom" value={status} onChange={(e) => setStatus(e.target.value)} required>
                                        <option value="Ativo">Ativo</option>
                                        <option value="Inativo">Inativo</option>
                                    </select>
                                </div>
                            </div>
                            <div className="row g-3 mt-1">
                                <div className="col-md-7">
                                    <label htmlFor="selectMarca" className="form-label-custom">Marca</label>
                                    <select id="selectMarca" className="form-select-custom" value={marcaId} onChange={(e) => setMarcaId(e.target.value)}>
                                        <option value="">Selecione...</option>
                                        {marcas.map((marca) => (<option key={marca.id} value={marca.id}>{marca.descricao}</option>))}
                                    </select>
                                </div>
                                <div className="col-md-5">
                                    <label htmlFor="selectUnidadeMedida" className="form-label-custom">Unidade de Medida</label>
                                    <select id="selectUnidadeMedida" className="form-select-custom" value={unidadeMedidaId} onChange={(e) => setUnidadeMedidaId(e.target.value)}>
                                        <option value="">Selecione...</option>
                                        {unidadesMedida.map((un) => (<option key={un.id} value={un.id}>{un.descricao}</option>))}
                                    </select>
                                </div>
                            </div>
                        </div>

                        {/* --- Seção: Detalhes --- */}
                        <div className="form-card">
                            <h5 className="form-section-header">
                                <i className="fas fa-truck-loading me-2"></i>
                                Detalhes & Valores
                            </h5>
                            <div className="row g-3">
                                <div className="col-md-12">
                                    <label htmlFor="selectFornecedor" className="form-label-custom">Fornecedor Principal</label>
                                    <select id="selectFornecedor" className="form-select-custom" value={fornecedorId} onChange={(e) => setFornecedorId(e.target.value)}>
                                        <option value="">Selecione um fornecedor...</option>
                                        {fornecedores.map((forn) => (<option key={forn.id} value={forn.id}>{forn.nome}</option>))}
                                    </select>
                                </div>
                            </div>
                            <div className="row g-3 mt-1">
                                <div className="col-md-6">
                                    <label htmlFor="inputValorCompra" className="form-label-custom">Valor de Compra (R$)</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-white border-end-0 text-muted">R$</span>
                                        <input onChange={(e) => handleValorChange(e, setValorCompra)} onBlur={() => formatarAoPerderFoco(valorCompra, setValorCompra)} type="text" className="form-control-custom border-start-0 ps-1" id="inputValorCompra" value={String(valorCompra).replace('.', ',')} placeholder="0,00" />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="inputValorVenda" className="form-label-custom">Valor de Venda (R$)</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-white border-end-0 text-muted">R$</span>
                                        <input onChange={(e) => handleValorChange(e, setValorVenda)} onBlur={() => formatarAoPerderFoco(valorVenda, setValorVenda)} type="text" className="form-control-custom border-start-0 ps-1" id="inputValorVenda" value={String(valorVenda).replace('.', ',')} placeholder="0,00" />
                                    </div>
                                </div>
                            </div>
                            <div className="row g-3 mt-1">
                                <div className="col-12">
                                    <label htmlFor="inputObservacoes" className="form-label-custom">Observações</label>
                                    <textarea className="form-control-custom" id="inputObservacoes" rows="3" value={observacoes} onChange={(e) => setObservacoes(e.target.value)} placeholder="Informações adicionais..."></textarea>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* --- Coluna da Direita: Variações --- */}
                    <div className="col-lg-4">
                        <div className="form-card h-100">
                            <h5 className="form-section-header">
                                <i className="fas fa-palette me-2"></i>
                                Variações
                            </h5>

                            <div className="form-check form-switch mb-3">
                                <input className="form-check-input" type="checkbox" id="checkControlarCores" checked={controlarCores} onChange={(e) => setControlarCores(e.target.checked)} />
                                <label className="form-check-label ms-2" htmlFor="checkControlarCores">Controlar cores</label>
                            </div>

                            {controlarCores && (
                                <div className="cores-section animate__animated animate__fadeIn">
                                    <label htmlFor="inputCor" className="form-label-custom">Adicionar Cor</label>
                                    <div className="input-group mb-3">
                                        <input onChange={(e) => setCurrentColor(e.target.value)} onKeyPress={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleAddColor(); } }} type="text" className="form-control-custom" id="inputCor" value={currentColor} placeholder="Ex: Azul" />
                                        <button className="btn btn-primary-custom px-3 py-1" style={{ borderRadius: '0 0.5rem 0.5rem 0' }} type="button" onClick={handleAddColor}>
                                            <i className="fas fa-plus"></i>
                                        </button>
                                    </div>

                                    <div className="text-muted small mb-2">Cores adicionadas ({colorsList.length}):</div>
                                    {Array.isArray(colorsList) && colorsList.length > 0 ? (
                                        <div className="d-flex flex-wrap gap-2">
                                            {colorsList.map((cor) => (
                                                <span key={cor} className="badge bg-light text-dark border p-2 d-flex align-items-center">
                                                    {cor}
                                                    <i className="fas fa-times ms-2 text-danger cursor-pointer" onClick={() => handleRemoveColor(cor)} style={{ cursor: 'pointer' }}></i>
                                                </span>
                                            ))}
                                        </div>
                                    ) : (
                                        <p className="text-muted small fst-italic">Nenhuma cor adicionada.</p>
                                    )}
                                </div>
                            )}

                            {!controlarCores && (
                                <div className="text-center text-muted py-5 opacity-50">
                                    <i className="fas fa-ban fa-3x mb-3"></i>
                                    <p>Cores desabilitadas</p>
                                </div>
                            )}

                        </div>
                    </div>
                </div>

            </div>
            <div className="form-actions-bar">
                <Link to='/app/insumos' className="btn-secondary-custom">
                    Cancelar
                </Link>
                <button type="submit" className="btn-primary-custom" disabled={loading}>
                    <i className={`fas ${loading ? 'fa-spinner fa-spin' : 'fa-save'} me-2`}></i>
                    {loading ? (isEditing ? 'Atualizando...' : 'Salvando...') : (isEditing ? 'Salvar Alterações' : 'Salvar Insumo')}
                </button>
            </div>
        </form>
    );
}

export default InsumoForm;